import { Directive, ElementRef, HostListener, Input } from '@angular/core';


/**
 * Enables focusing custom components that can be otherwise focused only programmatically.
 * Custom component must have [tabindex] attribute, to be able to handle focus event.
 *
 * If [tabindex] is set to -1, it won't be selectable with keyboard
 */
@Directive({
    selector: 'label[for]',
})
export class LabelForDirective {

    @Input('for') forId: string;

    constructor(private elementRef: ElementRef) {}

    @HostListener('click', ['$event'])
    focusElement(event: MouseEvent) {
        event.stopImmediatePropagation();
        event.preventDefault();
        let element = this.elementRef.nativeElement;
        do {
            const target = element.querySelector(`#${this.forId}`);
            if (target) {
                target.focus();
                target.click();
                return;
            }
            element = element.parentElement;
        } while (element);
    }
}
